import { appConfig } from '@/config/app.ts'

export interface TradeMarkState {
  isLoadingAllies: boolean
  isCreateTradeMarkModalOpen: boolean
  isEditTradeMarkModalOpen: boolean
  selectedTradeMarkId: string | null
  trademarkFilters: string
}

export const initialState: TradeMarkState = {
  isLoadingAllies: false,
  isCreateTradeMarkModalOpen: false,
  isEditTradeMarkModalOpen: false,
  selectedTradeMarkId: null,
  trademarkFilters: `?limit=${appConfig.pagination.defaultValue}`
}
